import type { Interface } from './Interface.js';
import { Resolver } from './Resolver.js';
import type * as _Window from './Window.js';

export const Api = new Resolver().proxy;

export type Api = Api.Uninitialized | Api.Initialized | Api.Loaded;

export namespace Api {
  export type Uninitialized =
    | {
        (...parameters: Interface.Parameters): void;

        q?: Array<unknown>;
        t?: number;
      }
    | undefined;

  export type Initialized = {
    (...parameters: Interface.Parameters): void;

    readonly q: Array<unknown>;
    readonly t: number;
  };

  export type Loaded = NoInfer<Initialized>;
}

export * from './Window.js';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/consistent-type-definitions
  interface Window extends _Window.Window {}
}
